import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Tools|Fulfillment Vouchers|Existing Batches';

export type SPExistingFulfillmentVoucherBatchesLocs =
	| 'SPExistingFulfillmentVoucherBatchesSectionTitle'
	| 'SPExistingFulfillmentVoucherBatchesBatchId'
	| 'SPExistingFulfillmentVoucherBatchesCreatedDate'
	| 'SPExistingFulfillmentVoucherBatchesExpireDate'
	| 'SPExistingFulfillmentVoucherBatchesRedeemedCount'
	| 'SPExistingFulfillmentVoucherBatchesRevokedCount'
	| 'SPExistingFulfillmentVoucherBatchesTotalCount'
	| 'SPFulfillmentVoucherBatchesSearchTokenButton'
	| 'SPFulfillmentVoucherBatchesChangeExpirationButton'
	| 'SPFulfillmentVoucherBatchesInvalidateButton'
	| 'SPFulfillmentVoucherBatchesChangeExpirationSuccess'
	| 'SPFulfillmentVoucherBatchesChangeExpirationFailure'
	| 'SPFulfillmentVoucherBatchesChangeExpirationCancelButton'
	| 'SPFulfillmentVoucherBatchesChangeExpirationConfirmButton'
	| 'SPFulfillmentVoucherBatchesChangeExpirationTitle'
	| 'SPFulfillmentVoucherBatchesChangeExpirationExpirationDate'
	| 'SPFulfillmentVoucherBatchesChangeExpirationExpirationDateRequired'
	| 'SPFulfillmentVoucherBatchesChangeExpirationRemoveExpirationDate'
	| 'SPFulfillmentVoucherBatchesInvalidateFailure'
	| 'SPFulfillmentVoucherBatchesInvalidateSuccess'
	| 'SPFulfillmentVoucherBatchesInvalidateCancelButton'
	| 'SPFulfillmentVoucherBatchesInvalidateConfirmButton'
	| 'SPFulfillmentVoucherBatchesInvalidateDescription'
	| 'SPFulfillmentVoucherBatchesInvalidateTitle'
	| 'SPFulfillmentVoucherBatchesDownloadButton'
	| 'SPExistingFulfillmentVoucherBatchesVoucherId'
	| 'SPExistingFulfillmentVoucherBatchesRedeemedBy'
	| 'SPExistingFulfillmentVoucherBatchesRedeemedDate'
	| 'SPExistingFulfillmentVoucherBatchesFulfillmentName'
	| 'SPExistingFulfillmentVoucherBatchesStatus';

export const spExistingFulfillmentVoucherBatchesLocs: LocDefs<SPExistingFulfillmentVoucherBatchesLocs> =
	{
		SPExistingFulfillmentVoucherBatchesSectionTitle: {
			defaultValue: 'Existing Fulfillment Voucher Batches',
			description: 'Title displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Section Title`,
			displayType: 'Title',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesBatchId: {
			defaultValue: 'Batch ID',
			description: 'Batch ID displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Batch ID`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesCreatedDate: {
			defaultValue: 'Created Date',
			description:
				'Created Date displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Created Date`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesExpireDate: {
			defaultValue: 'Expiration Date',
			description:
				'Expire Date displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Expire Date`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesRedeemedCount: {
			defaultValue: 'Redeemed',
			description:
				'Redeemed Count displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Redeemed Count`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesRevokedCount: {
			defaultValue: 'Revoked',
			description:
				'Revoked Count displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Revoked Count`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesTotalCount: {
			defaultValue: 'Voucher Count',
			description:
				'Total Count displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Total Count`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesSearchTokenButton: {
			defaultValue: 'Search Token',
			description: 'Button to search for a single fulfillment voucher token.',
			displayPath: `${dpRoot}|Search Token Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesChangeExpirationButton: {
			defaultValue: 'Change Expiration',
			description:
				'Button to change the expiration date of the selected fulfillment voucher batches.',
			displayPath: `${dpRoot}|Change Expiration Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesInvalidateButton: {
			defaultValue: 'Invalidate',
			description: 'Button to invalidate the selected fulfillment voucher batches.',
			displayPath: `${dpRoot}|Invalidate Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesChangeExpirationSuccess: {
			defaultValue: 'Expiration date changed successfully.',
			description:
				'Success message displayed when the expiration date of the selected fulfillment voucher batches is changed.',
			displayPath: `${dpRoot}|Change Expiration Success`,
			displayType: 'Notification',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesInvalidateSuccess: {
			defaultValue: 'Invalidated successfully.',
			description:
				'Success message displayed when the selected fulfillment voucher batches are invalidated.',
			displayPath: `${dpRoot}|Invalidate Success`,
			displayType: 'Notification',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesChangeExpirationFailure: {
			defaultValue: 'Expiration date change failed.',
			description:
				'Failure message displayed when the expiration date of the selected fulfillment voucher batches is changed.',
			displayPath: `${dpRoot}|Change Expiration Failure`,
			displayType: 'Notification',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesInvalidateFailure: {
			defaultValue: 'Invalidation failed.',
			description:
				'Failure message displayed when the selected fulfillment voucher batches are invalidated.',
			displayPath: `${dpRoot}|Invalidate Failure`,
			displayType: 'Notification',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesChangeExpirationCancelButton: {
			defaultValue: 'Cancel',
			description:
				'Cancel button displayed in the fulfillment voucher batches change expiration dialog.',
			displayPath: `${dpRoot}|Change Expiration Cancel Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesChangeExpirationConfirmButton: {
			defaultValue: 'Confirm',
			description:
				'Confirm button displayed in the fulfillment voucher batches change expiration dialog.',
			displayPath: `${dpRoot}|Change Expiration Confirm Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesChangeExpirationExpirationDate: {
			defaultValue: 'Expiration Date',
			description:
				'Expiration Date displayed in the fulfillment voucher batches change expiration dialog.',
			displayPath: `${dpRoot}|Change Expiration Expiration Date`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesChangeExpirationExpirationDateRequired: {
			defaultValue: 'Expiration Date is required.',
			description:
				'Expiration Date is required displayed in the fulfillment voucher batches change expiration dialog.',
			displayPath: `${dpRoot}|Change Expiration Expiration Date Required`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesChangeExpirationRemoveExpirationDate: {
			defaultValue: 'Remove Expiration Date',
			description:
				'Remove Expiration Date displayed in the fulfillment voucher batches change expiration dialog.',
			displayPath: `${dpRoot}|Change Expiration Remove Expiration Date`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesInvalidateCancelButton: {
			defaultValue: 'Cancel',
			description:
				'Cancel button displayed in the fulfillment voucher batches invalidate dialog.',
			displayPath: `${dpRoot}|Invalidate Cancel Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesInvalidateConfirmButton: {
			defaultValue: 'Confirm',
			description:
				'Confirm button displayed in the fulfillment voucher batches invalidate dialog.',
			displayPath: `${dpRoot}|Invalidate Confirm Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesInvalidateDescription: {
			defaultValue:
				'Are you sure you want to invalidate the selected fulfillment voucher batches?',
			description:
				'Description displayed in the fulfillment voucher batches invalidate dialog.',
			displayPath: `${dpRoot}|Invalidate Description`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesInvalidateTitle: {
			defaultValue: 'Invalidate Fulfillment Voucher Batches',
			description: 'Title displayed in the fulfillment voucher batches invalidate dialog.',
			displayPath: `${dpRoot}|Invalidate Title`,
			displayType: 'Title',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesChangeExpirationTitle: {
			defaultValue: 'Change Expiration Date',
			description:
				'Title displayed in the fulfillment voucher batches change expiration dialog.',
			displayPath: `${dpRoot}|Change Expiration Title`,
			displayType: 'Title',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherBatchesDownloadButton: {
			defaultValue: 'Download',
			description: 'Button to download the selected fulfillment voucher batches.',
			displayPath: `${dpRoot}|Download Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesVoucherId: {
			defaultValue: 'Voucher ID',
			description:
				'Voucher ID displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Voucher ID`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesRedeemedBy: {
			defaultValue: 'Redeemed By',
			description:
				'Redeemed By displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Redeemed By`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesRedeemedDate: {
			defaultValue: 'Redeemed Date',
			description:
				'Redeemed Date displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Redeemed Date`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesFulfillmentName: {
			defaultValue: 'Fulfillment Name',
			description:
				'Fulfillment Name displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Fulfillment Name`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPExistingFulfillmentVoucherBatchesStatus: {
			defaultValue: 'Status',
			description: 'Status displayed in the existing fulfillment voucher batches section.',
			displayPath: `${dpRoot}|Status`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
};

export const spExistingFulfillmentVoucherBatchesLocKeys =
	MapLocKeys<SPExistingFulfillmentVoucherBatchesLocs>(spExistingFulfillmentVoucherBatchesLocs);

export type SPExistingFulfillmentVoucherBatchesLocKeys =
	typeof spExistingFulfillmentVoucherBatchesLocKeys;
